"use client";

import Image from "next/image";
import AuthLogin from "@/app/auth/authForms/AuthLogin";
import AccessChangeNotice from "@/app/auth/components/AccessChangeNotice";
import LoginCarousel from "@/app/auth/components/LoginCarousel";
import PageContainer from "@/app/components/container/PageContainer";
import Logo from "@/app/layouts/full/shared/logo/Logo";

const Login = () => (
	<PageContainer
		title="Login"
		description="Sign in to access your Copilot account."
	>
		<div className="grid grid-cols-12 overflow-x-hidden !rounded-none">
			{/* Carousel pane: hidden below MUI's lg breakpoint (1200px). */}
			<div className="relative hidden h-screen overflow-hidden !rounded-none min-[1200px]:col-span-7 min-[1200px]:block 2xl:col-span-8">
				<LoginCarousel />
				<div className="absolute inset-0 z-[1] !rounded-none bg-gradient-to-r from-black/30 to-black/10" />
				<div className="relative z-[2] !rounded-none px-6 py-4">
					<Image
						src="/logo-white.svg"
						alt="Logo"
						width={200}
						height={70}
						style={{ height: "auto" }}
						priority
					/>
				</div>
			</div>
			<div className="col-span-12 flex min-h-screen items-center justify-center px-6 py-10 min-[1200px]:col-span-5 min-[1200px]:min-h-0 2xl:col-span-4">
				{/*
					A measure, not a percentage of the pane. `w-[90%]` plus `px-12`
					constrained the form twice and let the fields stretch to whatever
					the column happened to be: an email input the width of a desk.
					A login form is a single column of short fields, so it gets the
					width one reads comfortably and centres in whatever is left.
				*/}
				<div className="w-full max-w-[400px]">
					{/*
						The logo box is a fixed 70px tall with the mark centred in it, so
						it already carries its own air above and below. The margin here
						only has to finish the gap, not supply all of it.
					*/}
					<div className="mb-2">
						<Logo />
					</div>
					<AccessChangeNotice />
					<AuthLogin
						title={`Welcome to ${process.env.NEXT_PUBLIC_APP_NAME}`}
						subtext={
							/*
								The greeting and the form are two blocks, so the gap under
								the subtitle is bigger than the gaps inside the form. At the
								old `mb-2` the subtitle sat as close to the Email label as
								that label sits to its own input, and read as part of it.
							*/
							<p className="text-muted-foreground mb-8 text-sm">
								Your Admin Dashboard
							</p>
						}
					/>
				</div>
			</div>
		</div>
	</PageContainer>
);

export default Login;
